import { render } from "./ReturnInvoices.vue?vue&type=template&id=1ec5c51e"
import script from "./ReturnInvoices.vue?vue&type=script&lang=js"
export * from "./ReturnInvoices.vue?vue&type=script&lang=js"

import "./ReturnInvoices.vue?vue&type=style&index=0&id=1ec5c51e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__